import styled from 'styled-components';
import { Link } from 'react-router-dom';
import colors from 'theme/colors';

/*
 * Peças do formulário do painel claro, compartilhadas pela /entrar e pela
 * /cadastrar para as duas telas terem os mesmos campos, botão e rodapé.
 * Medidas e cores tiradas do layout de referência em 1600×828.
 */

export const ink = '#16112E';
export const accent = '#5C0BEA';

export const Title = styled.h1`
  font-size: 25.6px;
  line-height: 32px;
  font-weight: 700;
  color: ${ink};
  text-align: center;
  margin: 0;
`;

export const TitleAccent = styled.span`
  color: ${accent};
`;

export const Subtitle = styled.p`
  font-size: 14.9px;
  line-height: 22px;
  color: #68687A;
  text-align: center;
  margin-top: 8px;
`;

export const FieldGroup = styled.div`
  width: 100%;
  min-width: 0;
  margin-top: ${({ $first }) => $first ? '22px' : '23px'};
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12.4px;
  line-height: 16px;
  font-weight: 600;
  color: #150F2A;
  margin-bottom: 11px;
`;

export const InputShell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 50px;
  padding: 0 13px 0 10px;
  background: #F9F8FD;
  border: 1px solid ${({ $invalid }) => $invalid ? colors.dangerLight : '#ECEAF6'};
  border-radius: 12px;
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;

  &:focus-within {
    background: ${colors.neutralLight};
    border-color: ${colors.homeAccent};
    box-shadow: 0 0 0 3px rgba(105, 12, 228, .1);
  }

  & > input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    padding: 0 0 2px;
    font-size: 12.8px;
    color: ${ink};

    &::placeholder {
      color: #9FA0A9;
    }
  }
`;

export const IconBubble = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #EFECFB;
  color: #737181;
`;

export const TogglePassword = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #737181;
  cursor: pointer;

  &:hover {
    color: ${ink};
  }

  &:focus-visible {
    outline: 2px solid ${colors.homeAccent};
    outline-offset: 2px;
  }
`;

export const FieldError = styled.p`
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.35;
  color: ${colors.danger};
`;

export const SubmitButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  margin-top: 16px;
  border: none;
  border-radius: 25px;
  background: linear-gradient(90deg, #6419EA 0%, #6220F0 40%, #4C46F5 78%, #4B55FC 100%);
  color: ${colors.neutralLight};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(98, 32, 240, .22);
  transition: transform .15s ease, box-shadow .2s ease, opacity .2s ease;

  & > svg {
    position: absolute;
    right: 21px;
  }

  &:hover {
    box-shadow: 0 10px 24px rgba(98, 32, 240, .32);
  }

  &:active {
    transform: scale(.99);
  }

  &:disabled {
    opacity: .6;
    cursor: not-allowed;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const FooterRow = styled.p`
  font-size: 11.6px;
  line-height: 18px;
  color: #7B7991;
  text-align: center;
  margin-top: 31px;
`;

export const FooterLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-size: inherit;
  line-height: inherit;
  color: #7A4DEB;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: .8;
  }
`;

export const TermsText = styled.p`
  font-size: 11px;
  line-height: 1.5;
  color: #9A98AB;
  text-align: center;
  margin-top: 14px;
`;

export const LinkTerms = styled(Link)`
  text-decoration: underline;
  color: #7A4DEB;
  font-size: inherit;
`;
